import React, { Component } from "react";
import { connect } from "react-redux";
import { hashHistory } from "react-router";
import "./superFundDetailTab.css";
import Util from "../util.js";
import LineEchartPerformanceTrends from "./LineEchartPerformanceTrends.js";
import { AlerModleCommon } from "./fundDetail/AlerModle";
import ModalDetail  from "./Modal/ModalDetail";
import {getEvaluationIndicator} from '../action/portfolioAction'

class SuperFundDetailTab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tab: 0,
      resultShow: false,
      tsText: [],
      tipFlag: false,
      evaluationIndicator:{}
    };
  }
  componentDidMount() {
  }
  showWenHaoView = (event, val) => {
    event.stopPropagation();
    if (val == "盈利客户占比") {
      this.setState({
        tipFlag: true,
        tsText: ["该策略累计收益为正的用户数/该策略累计服务用户数"],
      });
    } else if (val == "客户委托管理平均时长") {
      this.setState({
        tipFlag: true,
        tsText: ["该策略累计服务用户数持仓天数之和/该策略累计服务用户数"],
      });
    }
  };
  goBack = () => {
    hashHistory.goBack();
  };
  changeTab = (value) => {
    if(value===1)this.props.dispatch(getEvaluationIndicator({superFundCode:this.props.superFundCode},(data)=>{
      this.setState({
        evaluationIndicator:data
      })
    }))
    this.setState({ tab: value });
  };
  c;
  render() {
    const {evaluationIndicator}=this.state
    return (
      <div className="Line_Tab_container">
        <div className="Line_Tab">
          <div
            onClick={() => {
              this.changeTab(0);
            }}
            className={this.state.tab === 0 ? "tab_active  first_tab" : "first_tab"}
          >
            <span>策略业绩表现</span>
          </div>
          <div
            onClick={() => {
              this.changeTab(1);
            }}
            className={this.state.tab === 1 ? "tab_active" : ""}
          >
            <span>策略评价指标</span>
          </div>
        </div>
        {this.state.tab == 0 && (
          <div className="Tab_content">
            <div className="Line_tip">业绩走势</div>
            <LineEchartPerformanceTrends />
          </div>
        )}
        {this.state.tab == 1 && (
          <div>
            <div className="Tab_second">
              <div className="Tab_second_infos">
                <div className="Tab_second_infos_item">
                  <span className="Tab_infos_value">{Util.toPercent(evaluationIndicator.profitCustRatio)}</span>
                  <div className="Tab_infos_tip">
                    <span>盈利客户占比</span>
                    <img
                      onClick={(event) => {
                        this.showWenHaoView(event, "盈利客户占比");
                      }}
                      /* onClick={this.handleAlert} */ style={{ width: ".24rem", marginLeft: ".1rem" }}
                      src={require("../img/n_icon_what .png")}
                    />
                  </div>
                </div>
                <div className="Tab_second_infos_item">
                  <span className="Tab_infos_value">{Util.processingDecimal(evaluationIndicator.custTrustManageAvgTime,1)}天</span>
                  <div className="Tab_infos_tip">
                    <span>客户委托管理平均时长</span>
                    <img
                      onClick={(event) => {
                        this.showWenHaoView(event, "客户委托管理平均时长");
                      }}
                      style={{ width: ".24rem", marginLeft: ".1rem" }}
                      src={require("../img/n_icon_what .png")}
                    />
                  </div>
                </div>
              </div>
              <div className="Tab_second_infos_updata_time">
                更新时间：<span style={{}}>{evaluationIndicator.updateTime||'--'}</span>
              </div>
            </div>
          </div>
        )}
        
        <ModalDetail
          flag={this.state.tipFlag}
          rightButtonTitle="知道了"
          titleBC={true}
          content={this.state.tsText}
          onOK={() => {
            this.setState({ tipFlag: false });
          }}
        />
   
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {};
}
export default connect(mapStateToProps)(SuperFundDetailTab);



// WEBPACK FOOTER //
// ./src/components/SuperFundDetailTab.js